const initialState = {
  isLoadingUserInfo: false
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER_INFO':
      return { ...state, userInfo: action.userInfo }
    case 'SET_IS_LOADING_USER_INFO':
      return { ...state, isLoadingUserInfo: true, lastRefreshedAt: new Date() }
    case 'REMOVE_IS_LOADING_USER_INFO':
      return { ...state, isLoadingUserInfo: false }
    case 'SET_LOGGED_OUT':
      return { ...initialState }
    default:
      return state
  }
}

export default users
